import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SynchroService {
    
    dateSynchro: Date;
    
    constructor(
      
    ) { }
    
    async synchronize() {
        //this.dateSynchro = new Date();
    }
    
}
